import classnames from 'classnames';
import * as React from 'react';
import TouchFeedback from 'rmc-feedback';
import { IS_IOS } from '../../utils/exenv';
function includes(arr, item) {
    if (!arr || !arr.length || !item) {
        return false;
    }
    for (let i = 0, len = arr.length; i < len; i++) {
        if (arr[i] === item) {
            return true;
        }
    }
    return false;
}
export class KeyboardItem extends React.Component {
    render() {
        const { prefixCls, onClick, className, disabled, children, tdRef, label, iconOnly, ...restProps } = this.props;
        let value = children;
        if (className === 'keyboard-delete') {
            value = 'delete';
        }
        else if (className === 'keyboard-hide') {
            value = 'hide';
        }
        else if (className === 'keyboard-confirm') {
            value = 'confirm';
        }
        const extraCls = {
            [`${prefixCls}-item-disabled`]: disabled,
        };
        const wrapCls = classnames(`${prefixCls}-item`, className, extraCls);
        return (createElement(TouchFeedback, { disabled: disabled, activeClassName: `${prefixCls}-item-active` },
            createElement("td", Object.assign({ ref: tdRef, onClick: e => {
                    onClick(e, value);
                }, className: wrapCls }, restProps),
                children,
                iconOnly && createElement("i", { className: "sr-only" }, label))));
    }
}
KeyboardItem.defaultProps = {
    prefixCls: 'im-number-keyboard-verify-code',
    onClick: () => { },
    disabled: false,
};
class CustomKeyboard extends React.Component {
    constructor() {
        super(...arguments);
        this.onKeyboardClick = (e, value = '') => {
            e.nativeEvent.stopImmediatePropagation();
            const disabledKeys = this.props.disabledKeys.concat([' ']);
            if (disabledKeys && includes(disabledKeys, value)) {
                return null;
            }
            if (this.linkedInput) {
                this.linkedInput.onKeyboardClick(value);
            }
        };
        this.renderKeyboardItem = (item, index) => {
            let disabled = false;
            const disabledKeys = this.props.disabledKeys.concat([' ']);
            if (disabledKeys && includes(disabledKeys, item)) {
                disabled = true;
            }
            if (item === ' ') {
                disabled = true;
            }
            return (createElement(KeyboardItem, { onClick: this.onKeyboardClick, key: `item-${item}-${index}`, disabled: disabled }, item));
        };
    }
    render() {
        const { prefixCls, backspaceLabel, wrapProps, header, type } = this.props;
        const wrapperCls = classnames(`${prefixCls}-wrapper`, {
            [`${prefixCls}-wrapper-inline`]: type === 'inline',
        });
        return (createElement("div", Object.assign({ className: wrapperCls, ref: el => (this.antmKeyboard = el) }, wrapProps),
            createElement("table", null,
                createElement("tbody", null,
                    header && (createElement("tr", null,
                        createElement(KeyboardItem, { className: "keyboard-confirm", colSpan: 3, onClick: this.onKeyboardClick, tdRef: el => (this.confirmKeyboardItem = el) }, header))),
                    createElement("tr", null, ['1', '2', '3'].map((item, index) => this.renderKeyboardItem(item, index))),
                    createElement("tr", null, ['4', '5', '6'].map((item, index) => this.renderKeyboardItem(item, index))),
                    createElement("tr", null, ['7', '8', '9'].map((item, index) => this.renderKeyboardItem(item, index))),
                    createElement("tr", null,
                        [' ', '0'].map((item, index) => this.renderKeyboardItem(item, index)),
                        createElement(KeyboardItem, Object.assign({ className: "keyboard-delete", onClick: this.onKeyboardClick }, this.getAriaAttr(backspaceLabel))))))));
    }
    getAriaAttr(label) {
        if (IS_IOS) {
            return { label, iconOnly: true };
        }
        else {
            return { role: 'button', 'aria-label': label };
        }
    }
}
CustomKeyboard.defaultProps = {
    prefixCls: 'im-number-keyboard',
    disabledKeys: [],
};
export default CustomKeyboard;
